<div [style.visibility]="show?'visible':'hidden'"
  class="custom-popup pit-utility-cable-popup risk-register-details modal left fade">
  <div class="modal-dialog" (clickOutside)="!isInteractionPaused && closePopup()" [exclude]="excludeSelectors">
    <div class="modal-content" [class.hidden-div]="loading">
      <ng-container *ngTemplateOutlet="riskHeader"></ng-container>
      @if (isParentAssessmentApproved) {
        <div class="assessment-locked-banner">
          <span class="material-icons">lock</span>
          <span>{{'This assessment is approved, so its registers are read-only. Un-approve the assessment to edit them.' | translate}}</span>
        </div>
      }
      <div class="top-tabs">
        <!-- DASH-3112: Consequence Rating moved out of the header to sit in line with the
        tabs, right-justified (reviewer request). Same binding/handler as before. -->
        <div class="tab-consequence-rating">
          <span class="round-btns grey-round-bg d-flex align-items-center">
            <label class="cr-label">
              {{'Consequence Rating:' | translate}}
            </label>
            @if (riskDetails) {
              <mat-select
                class="form-control cr-input"
                [(ngModel)]="riskDetails.consequenceRating"
                (selectionChange)="onConsequenceRatingChange(false)"
                [disabled]="isApproved"
                [ngModelOptions]="{standalone: true}"
                >
                @for (rating of consequenceRatings; track trackByOptionValue($index, rating)) {
                  <mat-option
                    [value]="rating.value">
                    {{ rating.value }} - {{ rating.label }}
                  </mat-option>
                }
              </mat-select>
            }
            <!-- DASH-2278: always-on info icon; hover shows a table of every consequence rating's description. -->
            @if (consequenceRatings?.length) {
              <span class="info-help-wrapper ml-1"
                [class.info-help-wrapper--pinned]="pinnedInfoPopover === 'consequence'">
                <span class="material-icons info-help-icon" (click)="toggleInfoPopover('consequence', $event)">info_outline</span>
                <div class="info-help-popover info-help-popover--below info-help-popover--right" (click)="$event.stopPropagation()">
                  <div class="info-help-popover-title">{{ 'Consequence Ratings' | translate }}</div>
                  <table class="info-help-table">
                    <tr>
                      <th>{{ 'Rating' | translate }}</th>
                      <th>{{ 'Description' | translate }}</th>
                    </tr>
                    @for (rating of consequenceRatings; track trackByOptionValue($index, rating)) {
                      <tr>
                        <td class="info-help-name">{{ rating.value }} - {{ rating.label }}</td>
                        <td>{{ rating.description || '—' }}</td>
                      </tr>
                    }
                  </table>
                </div>
              </span>
            }
          </span>
        </div>
        <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedRiskTab"
          (selectedTabChange)="updateRiskTableData($event)">
          <mat-tab label="{{ 'Risk Assessment' | translate }}">
            <ng-container *ngTemplateOutlet="riskAssessmentTemplate"></ng-container>
          </mat-tab>
          <mat-tab label="{{ 'Bayesian Analysis' | translate }}">
            @if (bayesianEnabled) {
              <ng-container *ngTemplateOutlet="bayesianAnalysisTemplate"></ng-container>
            } @else {
              <div class="modal-body px-4">
                <div class="bayesian-lock-state d-flex align-items-center justify-content-center flex-column">
                  <span class="material-icons bayesian-lock-icon">lock</span>
                  <h5>{{ 'Bayesian Analysis is available as an add-on feature' | translate }}</h5>
                  <p class="mb-0">{{ 'Contact your administrator to enable Bayesian Analysis for this jurisdiction.' | translate }}</p>
                </div>
              </div>
            }
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label> {{ 'Risk Treatment' | translate }}
              @if (!riskDetails?.isControlAdequate) {
                (<span class="red-text">{{ 'Required' | translate }}</span>)
              }
            </ng-template>
            <ng-container *ngTemplateOutlet="riskTreatmentTemplate"></ng-container>
          </mat-tab>
        </mat-tab-group>
      </div>

      <ng-template #riskAssessmentTemplate>
        <div class="modal-body px-4">
          @if (riskDetails) {
            <div class="cr-comment-section">
              <div class="cr-comment-header" (click)="toggleConsequenceRatingComment()">
                <h6 class="small-light-text mb-0 d-flex align-items-center">
                  {{'Consequence Rating Comment' | translate}}
                  @if (consequenceRatingChanged) {
                    <span class="red-text ml-1">*</span>
                  }
                  @if (hasConsequenceRatingComment && !isConsequenceRatingCommentOpen) {
                    <span class="material-icons cr-comment-indicator ml-2">chat_bubble</span>
                  }
                </h6>
                <span class="material-icons collapse-chevron ml-auto">
                  {{ isConsequenceRatingCommentOpen ? 'expand_less' : 'expand_more' }}
                </span>
              </div>
              @if (isConsequenceRatingCommentOpen) {
                <div class="comments-input mt-2">
                  <textarea
                    matInput
                    class="form-control"
                    [placeholder]="'Enter reason for change...' | translate"
                    rows="3"
                    [(ngModel)]="riskDetails.consequenceRatingComment"
                    (ngModelChange)="updateHasConsequenceRatingComment($event)"
                    [ngModelOptions]="{standalone: true}"
                    [required]="consequenceRatingChanged"
                    [readonly]="!consequenceRatingChanged">
                  </textarea>
                </div>
              }
            </div>
            @if (decisionNarrative) {
              <div class="ra-summary decision-narrative">
                <span class="material-icons stat-info-icon">info</span>
                <span>{{ decisionNarrative }}</span>
              </div>
            }
          }
          <div class="row">
            @if (riskDetails) {
              <div class="col-md-6 border-right pt-3">
                <div class="card-inner-main-div mb-2">
                  <div class="card-main-title">
                    <h6 class="small-light-text mb-2">{{ 'Method of Assessment' | translate }}</h6>
                  </div>
                  <div class="d-flex justify-content-between vertical-switch-div">
                    <div class="d-flex align-items-center">
                      <div class="method-of-assessment">
                        <mat-radio-group aria-label="Select an option"
                          [(ngModel)]="riskDetails.methodOfAssessment"
                          [disabled]="isApproved"
                          (ngModelChange)="onMethodOfAssessmentChange()" class="d-flex flex-column">
                          <mat-radio-button [value]="0">{{assessmentMethodEnum[0] | translate
                          }}</mat-radio-button>
                          <mat-radio-button [value]="1">{{assessmentMethodEnum[1] | translate
                          }}</mat-radio-button>
                          <mat-radio-button [value]="2">{{ 'Hazard Does Not Apply' | translate
                          }}</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                    <div class="required-method-txt">
                      <span class="bold">{{ 'Required Method of Assessment' | translate }}</span>
                      <div class="d-flex justify-content-end mt-1">
                        <span class="bold round-btns bordered-text">
                          {{assessmentMethodEnum[riskDetails.requiredMethodOfAssessment] |
                          translate}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-inner-main-div qualitative-card sky-box-shadow"
                  [class.assessment-card-active]="riskDetails?.methodOfAssessment === assessmentMethodEnum.Qualitative">
                  <div class="card-main-title qualitative-collapse-header"
                    (click)="isQualitativeExpanded = !isQualitativeExpanded">
                    <h6 class="small-light-text mb-2 d-flex align-items-center">
                      <img src="assets/images/diamond.svg" class="mr-2">
                      {{'Qualitative' | translate }}
                      <span class="material-icons collapse-chevron ml-auto">{{ isQualitativeExpanded ?
                      'expand_less' : 'expand_more' }}</span>
                    </h6>
                  </div>
                  @if (isQualitativeExpanded) {
                    <div class="list-bordered-card">
                      <div class="list-wrap qualitative-list ">
                        <ul class="row align-items-center">
                          <li class="col-4 d-flex align-items-center">{{ exceedanceProbabilityLabel }}
                            @if (isQualitativeAssessment && !isApproved) {
                              <span class="red-text">*</span>
                            }
                          </li>
                          <li class="col-4 d-flex align-items-center">
                            <mat-select
                              class="round-btns grey-round-bg mr-0 justify-content-center w-100"
                              (selectionChange)="setLikelihoodScore()"
                              [disabled]="isApproved"
                              [required]="isQualitativeAssessment"
                              [(ngModel)]="riskDetails.qualitativeExposureScore">
                              @for (option of exceedanceProbabilityList; track trackByOptionValue($index, option)) {
                                <mat-option
                                  [value]="option.value">{{ option.label | translate}}
                                </mat-option>
                              }
                            </mat-select>
                            <!-- DASH-2278: always-on info icon; hover shows a table of every option's description. -->
                            @if (exceedanceProbabilityList?.length) {
                              <span class="info-help-wrapper ml-1"
                                [class.info-help-wrapper--pinned]="pinnedInfoPopover === 'exceedanceProbability'">
                                <span class="material-icons info-help-icon" (click)="toggleInfoPopover('exceedanceProbability', $event)">info_outline</span>
                                <div class="info-help-popover" (click)="$event.stopPropagation()">
                                  <div class="info-help-popover-title">{{ exceedanceProbabilityLabel | translate }}</div>
                                  <table class="info-help-table">
                                    <tr>
                                      <th>{{ 'Option' | translate }}</th>
                                      <th>{{ 'Description' | translate }}</th>
                                    </tr>
                                    @for (option of exceedanceProbabilityList; track trackByIndex($index)) {
                                      <tr>
                                        <td class="info-help-name">{{ option.label | translate }}</td>
                                        <td>{{ option.description || '—' }}</td>
                                      </tr>
                                    }
                                  </table>
                                </div>
                              </span>
                            }
                          </li>
                          <li class="col-4 d-flex align-items-center">
                            {{ 'Exposure Score' | translate }}:
                            {{riskDetails.qualitativeExposureScore}}
                          </li>
                        </ul>
                        <ul class="row align-items-center">
                          <li class="col-4 d-flex align-items-center">{{ frequencyExposureLabel }}
                            @if (isQualitativeAssessment && !isApproved) {
                              <span class="red-text">*</span>
                            }
                          </li>
                          <li class="col-4 d-flex align-items-center">
                            <mat-select (selectionChange)="setLikelihoodScore()"
                              class="round-btns grey-round-bg mr-0 justify-content-center w-100"
                              [disabled]="isApproved"
                              [required]="isQualitativeAssessment"
                              [(ngModel)]="riskDetails.qualitativeFrequencyScore">
                              @for (option of frequencyExposureList; track trackByOptionValue($index, option)) {
                                <mat-option
                                  [value]="option.value">
                                  {{ option.label | translate }}
                                </mat-option>
                              }
                            </mat-select>
                            <!-- DASH-2278: always-on info icon; hover shows a table of every option's description. -->
                            @if (frequencyExposureList?.length) {
                              <span class="info-help-wrapper ml-1"
                                [class.info-help-wrapper--pinned]="pinnedInfoPopover === 'frequencyExposure'">
                                <span class="material-icons info-help-icon" (click)="toggleInfoPopover('frequencyExposure', $event)">info_outline</span>
                                <div class="info-help-popover" (click)="$event.stopPropagation()">
                                  <div class="info-help-popover-title">{{ frequencyExposureLabel | translate }}</div>
                                  <table class="info-help-table">
                                    <tr>
                                      <th>{{ 'Option' | translate }}</th>
                                      <th>{{ 'Description' | translate }}</th>
                                    </tr>
                                    @for (option of frequencyExposureList; track trackByIndex($index)) {
                                      <tr>
                                        <td class="info-help-name">{{ option.label | translate }}</td>
                                        <td>{{ option.description || '—' }}</td>
                                      </tr>
                                    }
                                  </table>
                                </div>
                              </span>
                            }
                          </li>
                          <li class="col-4 d-flex align-items-center">
                            {{ 'Frequency Score' | translate }}:
                            {{riskDetails.qualitativeFrequencyScore}}
                          </li>
                        </ul>
                      </div>
                      <div class="list-wrap quantitative-list ">
                        <ul class="row align-items-center">
                          <li class="col-md-12">
                            {{ 'Exposure Score X Frequency Score' | translate }}:
                            {{riskDetails?.qualitativeExposureScore *
                            riskDetails.qualitativeFrequencyScore}}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="rating-div text-center font-weight-bold d-flex align-items-center justify-content-center">
                      <span>
                        {{ 'Likelihood Rating' | translate }}:
                        @if (qualitativeLikelihoodText) {
                          <span>{{qualitativeLikelihoodText | translate}}</span>
                        }
                      </span>
                      <!-- DASH-2278: always-on info icon; hover shows a table of all likelihood-level descriptions. -->
                      @if (likelihoodLevelDescriptionsCache.length) {
                        <span class="info-help-wrapper ml-1"
                          [class.info-help-wrapper--pinned]="pinnedInfoPopover === 'likelihood'">
                          <span class="material-icons info-help-icon" (click)="toggleInfoPopover('likelihood', $event)">info_outline</span>
                          <div class="info-help-popover" (click)="$event.stopPropagation()">
                            <div class="info-help-popover-title">{{ 'Likelihood Levels' | translate }}</div>
                            <table class="info-help-table">
                              <tr>
                                <th>{{ 'Likelihood Factor' | translate }}</th>
                                <th>{{ 'Likelihood' | translate }}</th>
                                <th>{{ 'Description' | translate }}</th>
                              </tr>
                              @for (level of likelihoodLevelDescriptionsCache; track trackByIndex($index)) {
                                <tr>
                                  <td class="info-help-name">{{ level.score }}</td>
                                  <td class="info-help-name">{{ level.name | translate }}</td>
                                  <td>{{ level.description || '—' }}</td>
                                </tr>
                              }
                            </table>
                          </div>
                        </span>
                      }
                    </div>
                  }
                </div>
                <div class="card-inner-main-div form-card comments-card">
                  <div class="card-main-title">
                    <h6 class="small-light-text mb-2 d-flex align-items-center">
                      <img src="assets/images/comments-icon.svg" class="mr-2">
                      {{'Comments' | translate}}
                      @if (isQualitativeAssessment && !isApproved) {
                        <span class="red-text">*</span>
                      }
                    </h6>
                  </div>
                  <form>
                    @if (riskDetails) {
                      <div class="comments-input">
                        <textarea matInput class="form-control"
                          [placeholder]="'Enter Comments Here...' | translate" rows="4"
                          [ngModelOptions]="{standalone: true}"
                          [disabled]="isApproved"
                          [required]="isQualitativeAssessment"
                        [(ngModel)]="riskDetails.note"></textarea>
                      </div>
                    }
                  </form>
                  <div class="row align-items-center pt-3 mr-1">
                    <app-dynamic-form-field [field]="controlAssessmentField"
                    [entity]="riskDetails"></app-dynamic-form-field>
                  </div>
                  <ng-container *ngTemplateOutlet="ControlsTable"></ng-container>
                </div>
                <ng-container *ngTemplateOutlet="AttachmentsCard"></ng-container>
                <ng-container *ngTemplateOutlet="RiskButtons"></ng-container>
              </div>
            }
            <div class="col-md-6 pt-3">
              <div [class.oel-tabs]="filteredOelSections.length">
                <mat-tab-group [class.hidden-div]="!show" [(selectedIndex)]="selectedTabIndex"
                  (selectedTabChange)="onTabChange($event)">
                  @for (section of filteredOelSections; track trackByIndex($index)) {
                    <mat-tab [label]="(section | translate)"></mat-tab>
                  }
                </mat-tab-group>
              </div>
              <div [id]="CHART_DIV_ID" class="chart-section"
                [class.hidden-div]="isChartLoading || !filteredOelSections.length"
                style="width: 100%; height: 500px;">
              </div>
              <!-- Marker-state key for the Sample Results chart. Three marker styles with no
                   legend is a puzzle; kept muted and greyscale-distinguishable to match the
                   point styling. -->
              @if (showSampleMarkerLegend && !isChartLoading && filteredOelSections.length) {
                <div class="sample-marker-legend">
                  @for (marker of sampleMarkerLegend; track trackByIndex($index)) {
                    <span class="legend-item">
                      <span class="marker-swatch" [ngClass]="'marker-' + marker.state">
                        @if (sampleMarkerHasTick(marker.state)) {
                          <span class="marker-tick"></span>
                        }
                      </span>
                      <span>{{ marker.label | translate }}</span>
                    </span>
                  }
                </div>
              }
              <div>
                @if (isChartLoading) {
                  <app-widget-loader
                  class="vertically-center-div w-100 justify-content-center"></app-widget-loader>
                }
              </div>
              <!-- G19/DASH-2977 (FE-3, AC6): explicit empty state naming the cause,
              replacing the chart div that used to silently collapse. -->
              @if (!isChartLoading && plotEmptyStateMessage) {
                <div class="plot-empty-state">
                  <span class="material-icons">insights</span>
                  <span>{{ plotEmptyStateMessage }}</span>
                </div>
              }
              <div class="card-inner-main-div quantitative-card mx-3">
                <div class="quantitative-active-zone"
                  [class.assessment-card-active]="riskDetails?.methodOfAssessment === assessmentMethodEnum.Quantitative">
                <div class="card-main-title d-flex align-items-center justify-content-between">
                  <h6 class="small-light-text mb-2 d-flex align-items-center">
                    <img src="assets/images/quantitative-icon.svg" class="mr-2">
                    {{'Quantitative' | translate}}
                  </h6>
                  <div class="recalculate-wrap mb-2">
                    <span
                      [matTooltip]="canRecalculate
                        ? ('Recalculates this register and refreshes its statistics. Other registers in the assessment are not affected.' | translate)
                        : ('The Recalculate control is disabled while the parent assessment is Approved.' | translate)"
                      matTooltipPosition="above">
                      <button type="button" class="btn recalculate-btn"
                        [disabled]="!canRecalculate || loading"
                        (click)="recalculateAssessment()">
                        <i class="material-symbols-outlined">sync</i>
                        {{'Recalculate' | translate}}
                      </button>
                    </span>
                  </div>
                </div>
                <!-- G19/DASH-2977 (FE-3, AC7): escalated high-censoring (>=80%) warning. -->
                @if (riskDetails?.isHighCensoringFraction) {
                  <div class="censoring-warning-banner">
                    <span class="material-icons">warning_amber</span>
                    <span>{{ 'High proportion of non-detect results (>= 80%). Exposure statistics are highly uncertain — review before relying on them.' | translate }}</span>
                  </div>
                }
                <div class="list-bordered-card">
                  <div class="list-wrap qualitative-list ">
                    @if (riskDetails) {
                      <ul class="row align-items-center">
                        <li class="col-md-4">{{"No. of Samples" | translate}}</li>
                        <li class="col-md-6" (click)="openSampleSelector()"
                          [ngClass]="{'cursor-pointer': riskDetails.quantitativeNumberOfSamples >= 1}">
                          <span
                            class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                          {{riskDetails.quantitativeNumberOfSamples}}</span>
                          <!-- G19/DASH-2977 (FE-3, AC5): excluded non-detects called out from the
                          BE field so the drop in N is not read as missing data. -->
                          @if (riskDetails.excludedNonDetectCount) {
                            <span class="excluded-nondetect-note">
                              {{ '{{count}} non-detects excluded' | translate: { count: riskDetails.excludedNonDetectCount } }}
                            </span>
                          }
                        </li>
                        <li class="col-md-2 d-flex align-items-center">
                          <span class="check-icon ml-2">
                            @if (!riskDetails.quantitativeNumberOfSamples ||
                              riskDetails.quantitativeNumberOfSamples < riskDetails.requiredNumberOfSamples) {
                              <span class="exception-icon ml-2"
                                >
                                <img src="assets/images/Exception-Status.svg">
                              </span>
                            } @else {
                              <i class="ml-2 material-symbols-outlined">check</i>
                            }
                          </span>
                        </li>
                        <li class="col-md-4">{{'Sample Mean' | translate}}</li>
                        <li class="col-md-6">
                          <span
                            class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                            {{riskDetails.quantitativeMean ?
                          riskDetails.convertedQuantitativeMean : ''}} </span>
                        </li>
                        <li class="col-md-2 d-flex align-items-center"><span
                          class="check-icon ml-2">
                          @if (!riskDetails.quantitativeMean) {
                            <span class="exception-icon ml-2">
                              <img src="assets/images/Exception-Status.svg">
                            </span>
                          } @else {
                            <i class="ml-2 material-symbols-outlined">check</i>
                          }
                        </span>
                      </li>
                        <li class="col-md-4">{{'Estimated Mean (MVUE)' | translate}}
                          <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                          [matTooltip]="'MVUE (minimum-variance unbiased estimate): a best estimate of the average exposure that avoids systematic over- or under-estimation.' | translate">info_outline</span>
                        </li>
                        <li class="col-md-6">
                          <span
                            class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                            {{riskDetails.quantitativeMVUE ?
                          riskDetails.convertedQuantitativeMVUE : ''}} </span>
                        </li>
                        <li class="col-md-2 d-flex align-items-center"><span
                          class="check-icon ml-2">
                          @if (!riskDetails.quantitativeMVUE) {
                            <span class="exception-icon ml-2"
                              >
                              <img src="assets/images/Exception-Status.svg">
                            </span>
                          } @else {
                            <i class="ml-2 material-symbols-outlined">check</i>
                          }
                        </span>
                      </li>
                      <li class="col-md-4">{{'W-Test Output' | translate}}
                        <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                        [matTooltip]="'W-test (Shapiro–Wilk): checks whether the exposure data follow a log-normal distribution, which the statistics below assume.' | translate">info_outline</span>
                      </li>
                      <li class="col-md-6">
                        <span
                          class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                        {{riskDetails.wTestOutput}}</span>
                      </li>
                      <li class="d-flex align-items-center"><span class="check-icon ml-2">
                        @if (!riskDetails.isNormal && !riskDetails.isLogNormal) {
                          <span class="exception-icon ml-2"
                            >
                            <img src="assets/images/Exception-Status.svg">
                          </span>
                        } @else {
                          <i class="ml-2 material-symbols-outlined">check</i>
                        }
                      </span>
                    </li>
                    <li class="col-md-4">{{'Distribution Used' | translate}}</li>
                    <li class="col-md-6">
                      <span
                        class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                      {{riskDetails.distributionUsedLabel}}</span>
                    </li>
                    <li class="col-md-2"></li>
                    @if (qqFitSlope !== null && qqFitR2 !== null) {
                      <li class="col-md-4">{{'Q-Q Fit (Slope / R²)' | translate}}
                        <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                        [matTooltip]="'Q-Q fit: how closely the data match a log-normal distribution. A slope near 1 and R² near 1 indicate a good fit.' | translate">info_outline</span>
                      </li>
                      <li class="col-md-6">
                        <span
                          class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                        {{qqFitSlope | number: '1.2-2'}} / {{qqFitR2 | number: '1.2-3'}}</span>
                      </li>
                      <li class="col-md-2"></li>
                    }
                    <li class="col-md-4">{{'Geometric Mean' | translate}}
                      <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                      [matTooltip]="'Geometric mean: the typical exposure level. Exposure data are skewed, so the geometric mean represents the centre of the readings better than a plain average.' | translate">info_outline</span>
                    </li>
                    <li class="col-md-6">
                      <span
                        class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                        {{riskDetails.quantitativeGeometricMean ?
                        riskDetails.convertedQuantitativeGeometricMean: ''}}
                      </span>
                    </li>
                    <li class="col-md-2"><span class="check-icon ml-2">
                      @if (!riskDetails.quantitativeGeometricMean) {
                        <span class="exception-icon ml-2"
                          >
                          <img src="assets/images/Exception-Status.svg">
                        </span>
                      } @else {
                        <i class="ml-2 material-symbols-outlined">check</i>
                      }
                    </span>
                  </li>
                  <li class="col-md-4">{{'GSD' | translate}}
                    <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                    [matTooltip]="'Geometric standard deviation: how much the exposures vary. A value of 1 means every reading is identical; higher values mean the readings are more spread out.' | translate">info_outline</span>
                  </li>
                  <li class="col-md-6">
                    <span
                      class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                    {{riskDetails.quantitativeGSD | number: '1.0-2'}}</span>
                  </li>
                  <li class="col-md-2"><span class="check-icon ml-2">
                    @if (!riskDetails.quantitativeGSD || riskDetails.quantitativeGSD > 3) {
                      <span class="exception-icon ml-2"
                        >
                        <img src="assets/images/Exception-Status.svg">
                      </span>
                    } @else {
                      <i class="ml-2 material-symbols-outlined">check</i>
                    }
                  </span>
                </li>
                <li class="col-md-4">{{'95th Percentile' | translate}}</li>
                <li class="col-md-6">
                  <span
                    class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                    {{riskDetails.quantitative95thPercentile ?
                  riskDetails.convertedQuantitative95thPercentile : ''}} </span>
                </li>
                <li class="col-md-2 d-flex align-items-center"><span
                  class="check-icon ml-2">
                  @if (!riskDetails.quantitative95thPercentile) {
                    <span class="exception-icon ml-2">
                      <img src="assets/images/Exception-Status.svg">
                    </span>
                  } @else {
                    <i class="ml-2 material-symbols-outlined">check</i>
                  }
                </span>
              </li>
                <li class="col-md-4">
                  <div>{{'Decision Statistic Value' | translate}}
                    <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                    [matTooltip]="'Decision statistic: the value compared against the OEL to judge acceptability (for example, the 95th percentile or its upper confidence limit).' | translate">info_outline</span>
                  </div>
                  @if (riskDetails.quantitativeBDA) {
                    <div class="bold">
                    ({{riskDetails.quantitativeBDA}})</div>
                  }
                </li>
                <li class="col-md-6">
                  <span
                    class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                    {{riskDetails.quantitativeDecisionStatisticValue ?
                    riskDetails.convertedQuantitativeDecisionStatisticValue: ''}}
                  </span>
                </li>
                <li class="col-md-2"><span class="check-icon ml-2">
                  @if (!riskDetails.quantitativeDecisionStatisticValue) {
                    <span class="exception-icon ml-2"
                      >
                      <img src="assets/images/Exception-Status.svg">
                    </span>
                  } @else {
                    <i class="ml-2 material-symbols-outlined">check</i>
                  }
                </span>
              </li>
              <li class="col-md-4">{{'OEL' | translate}}</li>
              <li class="col-md-6">
                <span
                  class="round-btns grey-round-bg grey-text mr-0 justify-content-center w-100">
                {{riskDetails.oel ? (riskDetails.convertedCorrectedOEL ?? riskDetails.convertedOEL) : ''}}</span>
              </li>
              <li class="col-md-2"><span class="check-icon ml-2">
                @if (!riskDetails.oel) {
                  <span class="exception-icon ml-2"
                    >
                    <img src="assets/images/Exception-Status.svg">
                  </span>
                } @else {
                  <i class="ml-2 material-symbols-outlined">check</i>
                }
              </span>
            </li>
            <li class="col-md-4">{{'Result % Of OEL' | translate}}</li>
            <li class="col-md-6">
              <span
                class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                {{riskDetails.quantitativeResultPercentOfOEL | number: '1.0-2'}}
                @if (riskDetails.quantitativeResultPercentOfOEL) {
                  <span
                  >%</span>
                }</span>
              </li>
              <li class="col-md-2"><span class="check-icon ml-2">
                @if (!riskDetails.quantitativeResultPercentOfOEL) {
                  <span class="exception-icon ml-2"
                    >
                    <img src="assets/images/Exception-Status.svg">
                  </span>
                } @else {
                  <i class="ml-2 material-symbols-outlined">check</i>
                }
              </span>
            </li>
            <li class="col-md-4">{{'Exceedance Fraction' | translate}}</li>
            <li class="col-md-6">
              <span
                class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                {{riskDetails.quantitativeExceedenceFraction | number:
              '1.0-2'}}</span>
            </li>
            <li class="col-md-2"><span class="check-icon ml-2">
              @if (riskDetails.quantitativeExceedenceFraction === null) {
                <span class="exception-icon ml-2"
                  >
                  <img src="assets/images/Exception-Status.svg">
                </span>
              } @else {
                <i class="ml-2 material-symbols-outlined">check</i>
              }
            </span>
          </li>
        </ul>
      }
    </div>
  </div>
  <div class="rating-div text-center font-weight-bold d-flex align-items-center justify-content-center">
    <span>
      {{'Exposure Band' | translate}}:
      <span>{{ exposureBandText || ('N/A' | translate) }}@if (exposureBandRange) {
        <span
        > ({{ exposureBandRange }}{{ '% of OEL' | translate }})</span>
      }</span>
    </span>
  </div>
  <div class="rating-div text-center font-weight-bold d-flex align-items-center justify-content-center">
    <span>
      {{'Likelihood Rating' | translate}}:
      <span>{{quantitativeLikelihoodText || ('N/A' | translate)}}</span>
    </span>
    @if (quantitativeLikelihoodLevelsCache.length) {
      <span class="info-help-wrapper ml-1"
        [class.info-help-wrapper--pinned]="pinnedInfoPopover === 'quantitativeLikelihood'">
        <span class="material-icons info-help-icon" (click)="toggleInfoPopover('quantitativeLikelihood', $event)">info_outline</span>
        <div class="info-help-popover info-help-popover--right" (click)="$event.stopPropagation()">
          <div class="info-help-popover-title">{{ 'Likelihood Levels' | translate }}</div>
          <table class="info-help-table">
            <tr>
              <th>{{ 'Likelihood Value Factor' | translate }}</th>
              <th>{{ 'Quantitative Name' | translate }}</th>
              <th>{{ 'Quant % OEL' | translate }}</th>
            </tr>
            @for (level of quantitativeLikelihoodLevelsCache; track trackByIndex($index)) {
              <tr>
                <td class="info-help-name">{{ level.factor }}</td>
                <td class="info-help-name">{{ level.quantitativeName ? (level.quantitativeName | translate) : ('N/A' | translate) }}</td>
                <td>{{ level.quantOelRange || ('N/A' | translate) }}</td>
              </tr>
            }
          </table>
        </div>
      </span>
    }
  </div>
  </div>
  @if (riskDetails) {
    <div class="d-flex justify-content-center mt-3">
      <span class="bold round-btns bordered-text py-2"
        [ngStyle]="{'background-color':riskRatingColor}"
        [matTooltip]="consequenceRatingDescription"
        matTooltipPosition="above">
        {{'Health Risk Rating = Consequence Rating x Likelihood Rating' | translate}}:
        {{riskRating ? riskRating : ('N/A' | translate)}}
      </span>
    </div>
  }
  <!-- Risk Matrix Grid -->
  @if (riskDetails && matrixRows.length > 0) {
    <div class="risk-matrix-container mt-3">
      <div class="matrix-title text-center mb-2">
        <small class="text-muted">{{ 'Risk Matrix (Likelihood × Consequence)' | translate }}</small>
      </div>
      <div class="risk-matrix-grid">
        <!-- Column Headers (Consequence) -->
        <div class="matrix-row header-row">
          <div class="matrix-cell axis-label">{{ 'Likelihood / Consequence' | translate }}</div>
          @for (consequence of matrixColumns; track trackByIndex($index)) {
            <div class="matrix-cell consequence-header"
              [matTooltip]="consequence.description"
              matTooltipPosition="above">
              <div class="consequence-value">{{consequence.value}}</div>
              @if (consequence.label) {
                <div class="consequence-label">
                  {{consequence.label}}
                </div>
              }
            </div>
          }
        </div>
        <!-- Data Rows (Likelihood) -->
        @for (row of matrixRows; track trackByIndex($index); let rowIndex = $index) {
          <div class="matrix-row"
            >
            <!-- DASH-2278 #5/#10: show the configured likelihood factor/level
            name on the axis, not the raw 1-5 score. -->
            <div class="matrix-cell likelihood-label"
              [matTooltip]="row.classification"
              matTooltipPosition="left">
              <div class="likelihood-classification">{{row.classification | translate}}</div>
            </div>
            @for (cell of matrixCells[rowIndex]; track trackByIndex($index)) {
              <div class="matrix-cell"
                [ngStyle]="{'background-color': cell.color}"
                [class.active-cell]="cell.isActive"
                [matTooltip]="cell.tooltip"
                matTooltipPosition="above">
                @if (cell.isActive) {
                  <span class="cell-marker">●</span>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  <div class="list-bordered-card">
    <div class="row align-items-center">
      <div class="col-md-4 pb-2">
        <span class="material-grey-icon">{{'Adequacy of Controls' |
        translate}}</span>
      </div>
      <div class="col-md-6 pb-2">
        <span class="round-btns grey-round-bg mr-0 justify-content-center w-100">
          {{riskDetails?.isControlAdequate ? 'Adequate' :
        'Inadequate'}} </span>
      </div>
      <div class="col-md-2">
        @if (!riskDetails?.isControlAdequate) {
          <span class="exception-icon ml-2"
            >
            <img src="assets/images/Exception-Status.svg">
          </span>
        } @else {
          <i class="ml-2 material-symbols-outlined">check</i>
        }
      </div>
      <div class="col-md-4">
        <span class="material-grey-icon">{{'Resampling Frequency (Months)' |
        translate}}</span>
      </div>
      <div class="col-md-6">
        <span class="round-btns grey-round-bg mr-0 justify-content-center w-100">
        {{riskDetails?.reassessmentFrequencyMonths ?? '-'}}</span>
      </div>
    </div>
  </div>
  @if (riskDetails?.convertedOEL) {
    <div class="card-inner-main-div mt-3">
      <div class="card-main-title">
        <h6 class="small-light-text mb-2 d-flex align-items-center cursor-pointer"
          (click)="toggleOelCorrectionExpanded()">
          <i class="material-symbols-outlined mr-2">
            {{ oelCorrectionExpanded ? 'expand_less' : 'expand_more' }}
          </i>
          <span>{{ 'OEL Correction Details' | translate }}</span>
          @if (riskDetails?.totalOelCorrectionFactor && riskDetails.totalOelCorrectionFactor !== 1) {
            <span class="badge bg-warning ml-2"
              >
              {{ 'Adjusted' | translate }}
            </span>
          }
        </h6>
      </div>
      @if (oelCorrectionExpanded) {
        <div class="list-bordered-card mt-2">
          <div class="list-wrap qualitative-list">
            <ul class="row align-items-center">
              <li class="col-md-4">{{'Base OEL' | translate}}</li>
              <li class="col-md-8">{{ riskDetails?.oel != null ? riskDetails.convertedOEL : '-' }}</li>                                            </ul>
              <ul class="row align-items-center">
                <li class="col-md-4">{{'Corrected OEL' | translate}}</li>
                <li class="col-md-8">{{ riskDetails?.convertedCorrectedOEL ?? '-' }}</li>
              </ul>
              @if (riskDetails?.correctedDosePercent != null) {
                <ul class="row align-items-center">
                  <li class="col-md-4">{{'Corrected Dose %' | translate}}</li>
                  <li class="col-md-8">{{ riskDetails.correctedDosePercent | number: '1.0-2' }}%</li>
                </ul>
              }
              <ul class="row align-items-center">
                <li class="col-md-4">{{'Correction Method' | translate}}</li>
                <li class="col-md-8">{{ riskDetails?.oelCorrectionMethod != null ? (oelCorrectionMethodEnum[riskDetails.oelCorrectionMethod] | translate) : '-' }}</li>
              </ul>
              <ul class="row align-items-center">
                <li class="col-md-4">{{'Total Correction Factor' | translate}}</li>
                <li class="col-md-8">{{ riskDetails?.totalOelCorrectionFactor ?? 1 }}</li>
              </ul>
              @if (riskDetails?.oelCorrectionParams) {
                <div class="mt-3">
                  <h6 class="small-light-text mb-2">{{'Correction Parameters' | translate}}</h6>
                  <ul class="row align-items-center">
                    <li class="col-md-4">{{'Shift Length (hrs)' | translate}}</li>
                    <li class="col-md-8">{{ riskDetails?.oelCorrectionParams?.shiftLengthHours ?? '-' }}</li>
                  </ul>
                  <ul class="row align-items-center">
                    <li class="col-md-4">{{'Weekly Hours' | translate}}</li>
                    <li class="col-md-8">{{ riskDetails?.oelCorrectionParams?.weeklyHours ?? '-' }}</li>
                  </ul>
                  <ul class="row align-items-center">
                    <li class="col-md-4">{{'Atmospheric Pressure' | translate}}</li>
                    <li class="col-md-8">{{ riskDetails?.oelCorrectionParams?.pressureMmHg ?? '-' }}</li>
                  </ul>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
</div>
</div>
</ng-template>


<ng-template #bayesianAnalysisTemplate>
  @if (riskDetails) {
    <div class="modal-body px-4">
      <div class="bayesian-context-strip d-flex flex-wrap align-items-center mb-3">
        <div class="context-pill">
          <span class="label">{{ 'Framework' | translate }}:</span>
          <span class="value">{{ bayesianFrameworkLabel | translate }}</span>
        </div>
        <div class="context-pill">
          <span class="label">{{ 'Decision Statistic' | translate }}:</span>
          <span class="value">{{ bayesianDecisionStatisticLabel | translate }}</span>
        </div>
      </div>
      <div class="bayesian-active-prior d-flex align-items-center justify-content-between flex-wrap mb-3">
        <div class="prior-label">{{ 'Active Prior' | translate }}</div>
        <mat-radio-group [ngModel]="bayesianUseInformativePrior" class="d-flex align-items-center bayesian-prior-radio-group">
          <mat-radio-button [value]="false" (change)="toggleBayesianPrior(false)" class="mr-3">
            {{ 'Uninformative Prior' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="true" (change)="toggleBayesianPrior(true)" [disabled]="bayesianNoQraFallback || bayesianInformativeDisabled">
            {{ 'Informative Prior (QRA)' | translate }}
          </mat-radio-button>
          @if (bayesianInformativeDisabled) {
            <span class="coming-soon-chip">{{ 'Coming soon' | translate }}</span>
          }
        </mat-radio-group>
        <button
          mat-stroked-button
          class="bayesian-run-btn"
          [disabled]="bayesianRunLoading || !id"
          (click)="runBayesianAnalysisInPlace()">
          {{ bayesianRunButtonLabel | translate }}
        </button>
      </div>
      @if (bayesianPriorOverrideAuditNote) {
        <div class="bayesian-audit-note">
          <span class="material-icons">history</span>
          {{ bayesianPriorOverrideAuditNote | translate }}
        </div>
      }
      @if (bayesianResultStale) {
        <div class="bayesian-edge-banner bayesian-edge-info">
          <span class="material-icons">info</span>
          {{ 'Stored Bayesian analysis is stale because sample inputs changed. Re-run is required to refresh posterior outputs.' | translate }}
        </div>
      }
      @if (bayesianOelMissing) {
        <div class="bayesian-edge-banner bayesian-edge-warning">
          <span class="material-icons">warning_amber</span>
          {{ bayesianNoOelReason || ('OEL is not established for this agent, Bayesian decision state is unavailable.' | translate) }}
        </div>
      }
      @if (bayesianSamplesMissing) {
        <div class="bayesian-edge-banner bayesian-edge-warning">
          <span class="material-icons">warning_amber</span>
          {{ 'No samples are available for Bayesian analysis.' | translate }}
        </div>
      }
      @if (bayesianInsufficientSamples) {
        <div class="bayesian-edge-banner bayesian-edge-warning">
          <span class="material-icons">warning_amber</span>
          {{ 'At least 3 samples are required for Bayesian reliability; current sample count is {{count}}.' | translate: { count: bayesianSamplesUsed.length } }}
        </div>
      }
      @if (bayesianCensoringGuardrail) {
        <div class="bayesian-edge-banner bayesian-edge-info">
          <span class="material-icons">info</span>
          {{ 'Censoring guardrail: one or more samples are censored (< LOQ). Review prior assumptions and uncertainty.' | translate }}
        </div>
      }
      <div class="row">
        <div class="col-md-8">
          <div class="bayesian-zone bayesian-zone-distribution">
            <div class="zone-title d-flex align-items-center justify-content-between">
              <span>{{ 'Category Probability Distribution' | translate }}</span>
              <small>{{ 'Decision Probability by Exposure Rating' | translate }}</small>
            </div>
            <div class="bayesian-panel-grid">
              <div class="panel-row-head">{{ 'Prior' | translate }}</div>
              <div class="bayesian-panel" [id]="bayesianPanelIds.uninformativePrior"></div>
              <div class="panel-row-head">{{ 'Likelihood' | translate }}</div>
              <div class="bayesian-panel" [id]="bayesianPanelIds.uninformativeLikelihood"></div>
              <div class="panel-row-head">{{ 'Posterior' | translate }}</div>
              <div class="bayesian-panel" [id]="bayesianPanelIds.uninformativePosterior"></div>
            </div>
            @if (bayesianBandLegend.length) {
              <div class="bayesian-band-legend">
                @for (band of bayesianBandLegend; track trackByIndex($index)) {
                  <span class="legend-item">
                    <span class="legend-swatch" [style.background-color]="band.color"></span>
                    <span>{{ band.label }}</span>
                  </span>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-md-4">
          <div class="bayesian-zone bayesian-zone-decision">
            <div class="zone-title">{{ 'Decision Value' | translate }}</div>
            <div class="decision-value">{{ bayesianConvertedDecisionValue }}</div>
            <div class="decision-state"
                                    [ngClass]="{
                                        'state-below': bayesianDecisionState === 'below',
                                        'state-above': bayesianDecisionState === 'above',
                                        'state-unknown': bayesianDecisionState === 'unknown'
                                    }">
              {{ bayesianDecisionStateLabel | translate }}
            </div>
            <div class="decision-oel">{{ 'Reference OEL' | translate }}: {{ riskDetails.oel ? (riskDetails.convertedCorrectedOEL ?? riskDetails.convertedOEL) : '-' }}</div>
            @if (bayesianResultExplanation) {
              <div class="decision-explanation">
                <div class="explanation-title">{{ bayesianResultExplanation.title }}</div>
                <div class="explanation-body">{{ bayesianResultExplanation.body }}</div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="bayesian-zone bayesian-stats-zone mt-3">
        <div class="zone-title d-flex align-items-center justify-content-between">
          <span>{{ 'Posterior Statistics' | translate }}</span>
          <small>{{ 'Uninformative Prior' | translate }}</small>
        </div>
        <div class="custom-scrollbar table-responsive outer-bordered-table mt-2">
          <table class="bayesian-stats-table">
            <thead>
              <tr>
                <th>{{ 'Metric' | translate }}</th>
                <th>{{ 'Estimate' | translate }}</th>
                <th>{{ 'Median' | translate }}</th>
                <th>
                  {{ '90% Credible Interval' | translate }}
                  <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                  [matTooltip]="'90% credible interval: the range the true value is 90% likely to fall within, based on the samples.' | translate">info_outline</span>
                </th>
                <th>
                  {{ 'UCL 70%' | translate }}
                  <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                  [matTooltip]="'70% upper confidence limit: a cautious high-end estimate — we are 70% confident the true value is below this.' | translate">info_outline</span>
                </th>
                <th>
                  {{ 'UCL 90%' | translate }}
                  <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                  [matTooltip]="'90% upper confidence limit: an even more cautious high-end estimate — we are 90% confident the true value is below this (higher confidence gives a higher, more protective value).' | translate">info_outline</span>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (row of bayesianUninformativeMetrics; track trackByIndex($index)) {
                <tr
                  [class.metric-row-emphasis]="row.emphasis">
                  <td class="metric-label">
                    {{ row.label }}
                    @if (row.tooltip) {
                      <span class="material-icons stat-info-icon" matTooltipPosition="above" matTooltipClass="stat-info-tooltip"
                      [matTooltip]="row.tooltip | translate">info_outline</span>
                    }
                  </td>
                  <td>{{ row.estimate }}</td>
                  <td>{{ row.median }}</td>
                  <td>{{ row.credibleInterval }}</td>
                  <td>{{ row.ucl70 }}</td>
                  <td>{{ row.ucl90 }}</td>
                </tr>
              }
              @if (!bayesianUninformativeMetrics.length) {
                <tr>
                  <td class="text-center py-2" colspan="6">{{ 'No Data Found' | translate }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="bayesian-zone bayesian-samples-zone mt-3 d-flex align-items-center justify-content-between">
        <div class="zone-title mb-0">{{ 'Samples Used' | translate }}</div>
        <div class="bayesian-samples-count d-flex align-items-center"
          (click)="openSampleSelector()"
          [ngClass]="{'cursor-pointer': bayesianSamplesUsed.length >= 1}">
          <span class="round-btns grey-round-bg mr-0 justify-content-center">{{ bayesianSamplesUsed.length }}</span>
          <span class="ml-2">{{ 'samples' | translate }}</span>
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #riskTreatmentTemplate>
  <div class="modal-body px-4">
    <div class="row">
      @if (riskDetails) {
        <div class="col-md-6 border-right px-0">
          <div class="card-inner-main-div qualitative-card mb-0">
            <div class="row align-items-center py-2 mr-1">
              <app-dynamic-form-field [field]="controlTreatmentField"
              [entity]="riskDetails"></app-dynamic-form-field>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="ControlsTable"></ng-container>
          <ng-container *ngTemplateOutlet="RiskButtons"></ng-container>
        </div>
      }
      @if (riskDetails) {
        <div class="col-md-6 pt-3">
          <div class="card-inner-main-div quantitative-card mx-3">
            <div class="card-main-title">
              <h6 class="small-light-text mb-2 d-flex align-items-center">
                {{'Residual Risk Post-Treatment' | translate}}
              </h6>
              <div class="card-inner-main-div qualitative-card sky-box-shadow">
                <div class="card-main-title qualitative-collapse-header"
                  (click)="isQualitativeExpanded = !isQualitativeExpanded">
                  <h6 class="small-light-text mb-2 d-flex align-items-center">
                    <img src="assets/images/diamond.svg" class="mr-2">
                    {{ 'Qualitative' | translate }}
                    <span class="material-icons collapse-chevron ml-auto">{{
                    isQualitativeExpanded ? 'expand_less' : 'expand_more' }}</span>
                  </h6>
                </div>
                @if (isQualitativeExpanded) {
                  <div class="list-bordered-card">
                    <div class="list-wrap qualitative-list ">
                      <ul class="row align-items-center">
                        <li class="col-4 d-flex align-items-center">
                          {{ residualRiskExceedanceLabel }}
                        </li>
                        <li class="col-4 d-flex align-items-center">
                          <mat-select (selectionChange)="setResidualLikelihoodScore()"
                            class="round-btns grey-round-bg mr-0 justify-content-center w-100"
                            [disabled]="isApproved"
                            [(ngModel)]="riskDetails.residualExposureScore"
                            [matTooltip]="residualExposureDescription"
                            matTooltipPosition="above">
                            @for (option of exceedanceProbabilityList; track trackByOptionValue($index, option)) {
                              <mat-option
                                [value]="option.value">{{ option.label | translate}}
                              </mat-option>
                            }
                          </mat-select>
                        </li>
                        <li class="col-4 d-flex align-items-center">
                          {{'Exposure Score' | translate}}:
                          {{riskDetails.residualExposureScore}}
                        </li>
                      </ul>
                      <ul class="row align-items-center">
                        <li class="col-4 d-flex align-items-center">
                          {{ residualRiskFrequencyLabel }}
                        </li>
                        <li class="col-4 d-flex align-items-center">
                          <mat-select (selectionChange)="setResidualLikelihoodScore()"
                            class="round-btns grey-round-bg mr-0 justify-content-center w-100"
                            [disabled]="isApproved"
                            [(ngModel)]="riskDetails.residualFrequencyScore"
                            [matTooltip]="residualFrequencyDescription"
                            matTooltipPosition="above">
                            @for (option of frequencyExposureList; track trackByOptionValue($index, option)) {
                              <mat-option
                                [value]="option.value">
                                {{ option.label | translate }}
                              </mat-option>
                            }
                          </mat-select>
                        </li>
                        <li class="col-4 d-flex align-items-center">
                          {{'Frequency Score' | translate}}:
                          {{riskDetails.residualFrequencyScore}}
                        </li>
                      </ul>
                      <ul class="row align-items-center">
                        <li class="col-md-12">
                          {{'Exposure Score X Frequency Score' | translate}}:
                          {{riskDetails?.residualExposureScore *
                          riskDetails.residualFrequencyScore}}
                        </li>
                      </ul>
                      <ul class="row align-items-center">
                        <li class="col-4 d-flex align-items-center">{{'Notes' | translate}}
                        </li>
                        <li class="col-8 d-flex align-items-center">
                          <form class="w-100">
                            @if (riskDetails) {
                              <div class="comments-input">
                                <textarea matInput class="form-control"
                                  [(ngModel)]="riskDetails.residualNotes"
                                  [placeholder]="'Enter Notes Here...' | translate"
                                  rows="4"
                                  [disabled]="isApproved"
                                [ngModelOptions]="{standalone: true}"></textarea>
                              </div>
                            }
                          </form>
                        </li>
                      </ul>
                    </div>
                    @if (riskDetails) {
                      <div class="d-flex justify-content-center mt-3">
                        <span class="bold round-btns bordered-text py-2"
                          [ngStyle]="{'background-color':riskResidualRatingColor}"
                          [matTooltip]="consequenceRatingDescription"
                          matTooltipPosition="above">
                          {{'Residual Health Risk Rating = Consequence Rating x Likelihood Rating' | translate}}:
                          {{riskResidualRating ? riskResidualRating : ('N/A' | translate)}}
                        </span>
                      </div>
                    }
                    <div class="list-bordered-card">
                      <div class="row align-items-center">
                        <div class="col-md-4">
                          <span class="material-grey-icon">{{'Adequacy of Controls' |
                          translate}}</span>
                        </div>
                        <div class="col-md-6">
                          <span
                            class="round-btns grey-round-bg mr-0 justify-content-center w-100">
                            {{(riskDetails?.isPostTreatmentControlAdequate ? 'Adequate'
                            :
                          'Inadequate') | translate}} </span>
                        </div>
                        <div class="col-md-2 d-flex">
                          @if (!riskDetails?.isPostTreatmentControlAdequate) {
                            <span class="exception-icon ml-2"
                              >
                              <img src="assets/images/Exception-Status.svg">
                            </span>
                          } @else {
                            <i class="ml-2 material-symbols-outlined">check</i>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #riskHeader>
  @if (riskDetails) {
    <div class="modal-header risk-header d-flex justify-content-between align-items-start">
      <div class="d-flex flex-column risk-header-title">
        <h6 class="modal-title card-title text-truncate"
          [title]="riskDetails.segName + ' - ' + riskDetails.agentName">
          {{ riskDetails.segName}} - {{riskDetails.agentName}}
        </h6>
        <span class="date-section">
          {{'Time Period:' | translate}}
          <input matInput [(ngModel)]="startDate" [max]="endDate" [matDatepicker]="startPicker"
            (ngModelChange)="dateChange('start')" [readonly]="!editDateRange"
            (click)="editDateRange && startPicker.open(); pickerEnabled() ">
            <mat-datepicker #startPicker (closed)="pickerEnabled(false)"></mat-datepicker>
            -
            <input matInput [(ngModel)]="endDate" [min]="startDate" [matDatepicker]="endPicker"
              (ngModelChange)="dateChange('end')" [readonly]="!editDateRange"
              (click)="editDateRange && endPicker.open(); pickerEnabled()">
              <mat-datepicker #endPicker (closed)="pickerEnabled(false)"></mat-datepicker>
              <span class="date-selector edit-date cursor-pointer ml-2" [hidden]="editDateRange || isApproved"
                (click)="toggleDateChange()">
                <i class="material-symbols-outlined purple-text">edit</i>
              </span>
              <span class="date-selector confirm-date cursor-pointer ml-2" [hidden]="!editDateRange"
                (click)="saveDateChange()">
                <i class="material-symbols-outlined green-text">check</i>
              </span>
              <span class="date-selector edit-date cursor-pointer ml-2" [hidden]="!editDateRange"
                (click)="toggleDateChange(false)">
                <i class="material-symbols-outlined red-text">close</i>
              </span>
            </span>
          </div>
          <div class="d-flex flex-column align-items-end risk-header-status">
            <div class="d-flex align-items-end flex-wrap justify-content-end risk-header-controls">
                            <div class="status-div d-flex align-items-center" [ngStyle]="{'border': '1px solid'+riskDetails.statusColor,
                                            'color': riskDetails.statusColor}">
                <img [src]="riskDetails.imageSrc" class="mr-1">
                {{riskRegisterAssessmentStatusEnum[riskDetails?.assessmentStatus] | translate}}
              </div>
              <!-- DASH-3112: Exposure Band, EN 689 Compliance and Risk Rating share the same
              label-above-coloured-chip layout (.header-metric) so all three align. -->
              <div class="header-metric d-flex flex-column align-items-center">
                <span class="header-metric-label light-grey-text">{{ 'Exposure Band' | translate }}</span>
                <div class="status-div header-metric-chip d-flex flex-column align-items-center"
                  [ngStyle]="{'background-color':exposureLabelColor}">
                  <span>{{ exposureLabelValue || ('N/A' | translate) }}</span>
                  @if (headerBandRange) {
                    <span class="exposure-band-range">
                    {{ headerBandRange }}{{ '% of OEL' | translate }}</span>
                  }
                </div>
              </div>
              @if (complianceDisplay) {
                <div class="header-metric d-flex flex-column align-items-center">
                  <span class="header-metric-label light-grey-text">{{ 'EN 689 Compliance' | translate }}</span>
                  <div class="status-div header-metric-chip d-flex align-items-center"
                    [ngStyle]="{'border': '1px solid '+complianceDisplay.color, 'color': complianceDisplay.color}">
                    <img [src]="complianceDisplay.icon" class="mr-1">
                    {{ complianceDisplay.label | translate }}
                  </div>
                </div>
              }
              <div class="header-metric d-flex flex-column align-items-center">
                <span class="header-metric-label light-grey-text">{{ 'Risk Rating' | translate }}</span>
                <span class="round-btns grey-round-bg header-metric-chip" [ngStyle]="{'background-color':riskRatingColor}">
                  {{ riskRatingName || ('N/A' | translate) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-template>
    <ng-template #RiskButtons>
      <div class="btns-div d-flex mt-4">
        <span class="status-draft-btn dark-grey-bg" [class.green-bg]="riskStatus == 'Approved'">
          {{'Status:' | translate}}
          <mat-select class="mr-0" [(ngModel)]="riskStatus" [disabled]="isParentAssessmentApproved" panelClass="options-box-auto">
            <mat-option value="Draft">{{'Drafted' | translate}}</mat-option>
            <mat-option value="Approved">{{'Approved' | translate}}</mat-option>
          </mat-select>
        </span>
        <div class="btns-pair">
          <button type="button" class="btn modal-footer-btn save-modal-btn w-50" [disabled]="isParentAssessmentApproved || (consequenceRatingChanged && !hasConsequenceRatingComment) || (!isApproved && isQualitativeCommentMissing) || (!isApproved && isQualitativeScoreMissing)" (click)="save()">{{'Save' | translate}}</button>
          <a class="btn modal-footer-btn cancel-modal-btn w-50" (click)="closePopup()">{{'Close' |
          translate}}</a>
        </div>
      </div>
    </ng-template>

    <ng-template #ControlsTable>
      <div class="custom-theme-table pt-0">
        <div class="custom-scrollbar table-responsive outer-bordered-table">
          <table mat-table [dataSource]="dataSource">

            <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row':loading}">
              <td class="mat-cell text-center py-2" [attr.colspan]="displayedColumns.length">
                {{ 'No Data Found' | translate }}
              </td>
            </tr>

            <ng-container matColumnDef="controlHierarchyBucketName">
              <th mat-header-cell *matHeaderCellDef>{{ 'Control Bucket' | translate }} </th>
              <td mat-cell *matCellDef="let element">{{element.controlHierarchyBucketName != null ?
              element.controlHierarchyBucketName : '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'Control Name' | translate }} </th>
              <td mat-cell *matCellDef="let element">{{element.name != null ?
              element.name : '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="controlType">
              <th mat-header-cell *matHeaderCellDef>{{ 'Control Type' | translate }} </th>
              <td mat-cell *matCellDef="let element">{{element.controlType != null ?
              controlTypeEnum[element.controlType] : '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="segOrgStatus">
              <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }} </th>
              <td mat-cell *matCellDef="let element">{{ element?.segOrgStatus }}</td>
            </ng-container>

            <ng-container matColumnDef="targetImplementationEnd">
              <th mat-header-cell *matHeaderCellDef>{{ 'Target Implementation End Date' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">{{ element?.targetImplementationEnd ?
              ($safeNavigationMigration(element?.targetImplementationEnd) | dateFormat) : '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="ownerName">
              <th mat-header-cell *matHeaderCellDef>{{ 'Owner Name' | translate }} </th>
              <td mat-cell *matCellDef="let element">{{ element.ownerName ?? '-' }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
            [class.even-row]="even"> </tr>
          </table>
        </div>
      </div>
    </ng-template>

    <ng-template #AttachmentsCard>
      <div class="card-inner-main-div form-card attachments-card">
        <div class="card-main-title attachments-card-header">
          <h6 class="small-light-text mb-2 d-flex align-items-center">
            <span class="material-icons mr-2 attachments-title-icon">attachment</span>
            {{ 'Attachments' | translate }}
          </h6>
          @if (canAddAttachment) {
            <button type="button" class="btn add-attachment-btn" (click)="openAddAttachmentDialog()">
              <i class="material-symbols-outlined">add</i>
              {{ 'Add Attachment' | translate }}
            </button>
          }
        </div>
        @if (attachmentsLocked) {
          <p class="attachments-locked-hint">
            {{ 'Attachments are locked while the risk register is approved.' | translate }}
          </p>
        }
        <div class="custom-theme-table pt-0">
          <div class="custom-scrollbar table-responsive outer-bordered-table">
            <table mat-table [dataSource]="attachmentsDataSource">

              <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row': attachmentsLoading}">
                <td class="mat-cell text-center py-2" [attr.colspan]="attachmentDisplayedColumns.length">
                  {{ 'No Data Found' | translate }}
                </td>
              </tr>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ 'File Name' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <button type="button" class="attachment-link" (click)="openAttachment(element)">
                    {{ element.name }}
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>{{ 'Description' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.description || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="typeLabel">
                <th mat-header-cell *matHeaderCellDef>{{ 'Type' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.typeLabel | translate }}</td>
              </ng-container>

              <ng-container matColumnDef="sizeLabel">
                <th mat-header-cell *matHeaderCellDef>{{ 'Size' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.sizeLabel }}</td>
              </ng-container>

              <ng-container matColumnDef="uploadedByName">
                <th mat-header-cell *matHeaderCellDef>{{ 'Uploaded By' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.uploadedByName }}</td>
              </ng-container>

              <ng-container matColumnDef="dateCreated">
                <th mat-header-cell *matHeaderCellDef>{{ 'Uploaded' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.dateCreated ? (element.dateCreated | dateFormat) : '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  @if (!attachmentsLocked) {
                    <button type="button" class="remove-attachment-btn" [title]="'Remove attachment' | translate"
                      (click)="confirmRemoveAttachment(element)">
                      <i class="material-symbols-outlined">delete</i>
                    </button>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="attachmentDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; let even = even; columns: attachmentDisplayedColumns;"
              [class.even-row]="even"> </tr>
            </table>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  @if (loading) {
    <app-widget-loader
    class="vertically-center-div w-100 justify-content-center"></app-widget-loader>
  }
</div>
</div>

